import React from "react";
import { useEffect } from "react";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useState } from "react";
import HandoverNoteContainer from "../Notes/HandoverNoteContainer";
import { CircularProgress } from "@mui/material";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";

function HandoverNotesAll(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "handoverNote"),
      orderBy("effectiveDateTime", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      const notesData = [];
      querySnapshot.forEach((doc) => {
        notesData.push({ id: doc.id, ...doc.data() });
      });
      setLoading(false);
      setNotes(notesData);
      try { incrementDailyReads("notes_handover", querySnapshot.size); } catch {}
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note, index) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <div key={note.id || index} style={{ paddingBottom: "15px" }}>
              <HandoverNoteContainer
                key={note.id}
                noteContent={note.noteContent}
                effectiveDateTime={note.effectiveDateTime}
                noteDate={formattedDate}
                noteTime={formattedTime}
                doneBy={note.doneBy}
                timeStamp={formattedTimestamp}
                lastModification={formattedLastModification}
                noteId={note.id}
                immmigrationAppointment={note.immmigrationAppointment}
                dischargesSwot={note.dischargesSwot}
                newClients={note.newClients}
                medicalInfos={note.medicalInfos}
                hospitalAppointment={note.hospitalAppointment}
                residentialClientMovements={note.residentialClientMovements}
                zoomSessionAssistance={note.zoomSessionAssistance}
                updateAt={note.updateAt}
                createdAt={note.createdAt}
                staffToday={note.staffToday}
                generalAnnouncement={note.generalAnnouncement}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default HandoverNotesAll;
